import { Component } from '@angular/core';
import packageInfo from '../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent {

  public date: number;

  constructor() {
    this.date = new Date().getFullYear();
  }

  get appVersion(): string {
    return packageInfo.version;
  }
}
